<template>
  <AttrSelect
    label="显示规则"
    tooltip="在手表切换温度单位时，是否显示或隐藏该图层？"
    :value="shape.attrs['renderRule' as 'name'] ?? 'alwaysShow'"
    :options="options"
    :disabled="!!disabled"
    :width="180"
    @change="onChange"
  />
</template>
<script lang="ts" setup>
import { Shape } from '@/services/shape';
import { PropType, computed } from 'vue';

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const options = computed(() => {
  return [
    { label: '单位不一致时隐藏', value: 'hideWhenUnitMismatch' },
    { label: '一直显示', value: 'alwaysShow' }
  ];
});

const onChange = (val: Shape['attrs']['temperatureUnitType']) => {
  props.shape.setAttrs({ ['renderRule' as 'name']: val });
};
</script>
